// solution found on https://github.com/Alexandrshy/keukenhof/blob/master/src/index.ts

import { gsap } from "gsap";

export const AdScrollRevealDefaultSmall = (options) => {

  // Default settings
  let defaults = {
    classTarget: "",
    scroller: null,
    toggleActions: "play none none none",
    start: "top 94%",
    end: "bottom center",
    stagger: 0.2,
    y: "32px",
    opacity: 0,
    duration: 1,
    ease: "circ.out",
  };

  let settings = Object.assign({}, defaults, options);

  const scrollReavealDefault = gsap.utils.toArray(settings.classTarget);
  if (scrollReavealDefault) {
    scrollReavealDefault.forEach((item) => {

      let tl = gsap.timeline({
        scrollTrigger: {
          scroller: settings.scroller,
          trigger: item,
          start: settings.start,
          end: settings.end,
          toggleActions: settings.toggleActions,
          stagger: settings.stagger,
        },
      })
      tl.from(item, {
        y: settings.y,
        opacity: settings.opacity,
        duration: settings.duration,
        ease: settings.ease,
      });
    });
  }

}

export const AdScrollRevealDefaultMedium = (options) => {

  // Default settings
  let defaults = {
    classTarget: "",
    scroller: null,
    toggleActions: "play none none none",
    start: "top bottom",
    end: "top 100%",
    stagger: 0.1,
    y: "32px",
    opacity: 0,
    duration: 1,
    ease: "circ.out",
  };

  let settings = Object.assign({}, defaults, options);

  const scrollReavealDefault = gsap.utils.toArray(settings.classTarget);
  if (scrollReavealDefault) {
    scrollReavealDefault.forEach((item) => {

      let tl = gsap.timeline({
        scrollTrigger: {
          scroller: settings.scroller,
          trigger: item,
          // start: settings.start,
          // end: settings.end,
          toggleActions: settings.toggleActions,
          stagger: settings.stagger,
        },
      })
      tl.from(item, {
        y: settings.y,
        opacity: settings.opacity,
        duration: settings.duration,
        ease: settings.ease,
      });
    });
  }

}

export const AdScrollRevealDefaultBig = (options) => {




  // Default settings
  let defaults = {
    classTarget: "",
    scroller: null,
    toggleActions: "play none none none",
    start: "top 94%",
    end: "bottom center",
    stagger: 0.1,
    y: "64px",
    opacity: 0,
    duration: 1,
    ease: "circ.out",
  };

  let settings = Object.assign({}, defaults, options);

  const scrollReavealDefault = gsap.utils.toArray(settings.classTarget);
  if (scrollReavealDefault) {
    scrollReavealDefault.forEach((item) => {

      let tl = gsap.timeline({
        scrollTrigger: {
          scroller: settings.scroller,
          start: settings.start,
          trigger: item,
          toggleActions: settings.toggleActions,
          stagger: settings.stagger,
        },
      })
      tl.from(item, {
        y: settings.y,
        opacity: settings.opacity,
        duration: settings.duration,
        ease: settings.ease,
      });
    });
  }

}

export const AdScrollRevealFadeIn = (options) => {




  // Default settings
  let defaults = {
    classTarget: "",
    classOpacity: "",
    scroller: null,
    toggleActions: "play none none none",
    start: "top 90%",
    end: "top 90%",
    scale: 1.4,
    opacity: 0,
    duration: 0.8,
    ease: "circ.out",
    easeOpacity: "circ.out",
  };

  let settings = Object.assign({}, defaults, options);

  const scrollReavealDefault = gsap.utils.toArray(settings.classTarget);
  if (scrollReavealDefault) {
    scrollReavealDefault.forEach((item) => {

      const scrollReavealDefaultOpacity = item.querySelector(settings.classOpacity)

      let tl = gsap.timeline({
        scrollTrigger: {
          scroller: settings.scroller,
          trigger: item,
          start: settings.start,
          end: settings.end,
          toggleActions: settings.toggleActions,
        },
      })
      tl.from(item, {
        scale: settings.scale,
        duration: settings.duration,
        ease: settings.ease,
      });
      tl.from(scrollReavealDefaultOpacity, {
        opacity: settings.opacity,
        duration: settings.duration,
        ease: "linear",
      }, `-=${settings.duration}`)
    });
  }

}


export const AdScrollRevealDefaultStagger = (options) => {


  // Default settings
  let defaults = {
    classTarget: "",
    secondClassTarget: "",
    scroller: null,
    toggleActions: "play none none none",
    start: "top 94%",
    end: "bottom center",
    y: "20%",
    opacity: 0,
    duration: 0.8,
    stagger: 0.05,
    ease: "circ.out",
  };

  let settings = Object.assign({}, defaults, options);

  const scrollReavealWrapper = gsap.utils.toArray(settings.classTarget);
  if (scrollReavealWrapper) {
    scrollReavealWrapper.forEach((Wrap) => {
      const scrollReavealDefault = Wrap.querySelectorAll(
        settings.secondClassTarget
      );
      gsap.from(scrollReavealDefault, {
        scrollTrigger: {
          scroller: settings.scroller,
          trigger: Wrap,
          start: settings.start,
          end: settings.end,
          toggleActions: settings.toggleActions,
        },
        y: settings.y,
        opacity: settings.opacity,
        duration: settings.duration,
        stagger: settings.stagger,
        ease: settings.easeOpacity,
      });
    });
  }

}